var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 0C6.26801 0 0 6.26801 0 14C0 21.732 6.26801 28 14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0ZM6.72092 11.5953H9.89363V21.128H6.72092V11.5953ZM10.1026 8.64657C10.082 7.7119 9.41365 7 8.32829 7C7.24293 7 6.53335 7.7119 6.53335 8.64657C6.53335 9.56188 7.22196 10.2943 8.28711 10.2943H8.30738C9.41365 10.2943 10.1026 9.56188 10.1026 8.64657ZM17.6827 11.3716C19.7705 11.3716 21.3357 12.7343 21.3357 15.6623L21.3355 21.1281H18.163V16.0281C18.163 14.7471 17.7038 13.873 16.5553 13.873C15.6788 13.873 15.1567 14.4622 14.9274 15.0314C14.8435 15.2354 14.8229 15.5196 14.8229 15.8045V21.1283H11.6498C11.6498 21.1283 11.6916 12.4901 11.6498 11.5957H14.8229V12.9459C15.244 12.2968 15.9982 11.3716 17.6827 11.3716Z",
    fill: "#005BBC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.42a84a03ff1b2105ebb993b44426ad58.svg";
export { ForwardRef as ReactComponent };